import axios from "axios";

const TRANS_URL = process.env.REACT_APP_TRANSACTION_API_URL;

export async function getEnquiryReport() {
    const response = await axios
        .get(TRANS_URL + "/enquiryreport/getallreport")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });

    return response.data;
}

export async function getFilteredEnquiryReport(filters) {
    const response = await axios
        .post(TRANS_URL + "/enquiryreport/getfilteredreport", filters)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });

    return response.data;
}
